export default __webpack_public_path__ + "static/media/office1-before1-768w.d5e1df67.webp";